export const actions = {
    LOGIN: 'LOGIN',
    SIGNUP: 'signup'
};

export async function execute({ reCaptchaId, action }) {
    if (!window.grecaptcha?.enterprise) {
        throw new Error('grecaptcha.enterprise not available or loaded');
    }

    if (!reCaptchaId) {
        throw new Error('grecaptcha.enterprise.execute requires a reCaptchaId');
    }

    if (!action) {
        throw new Error('grecaptcha.enterprise.execute requires an action');
    }

    return new Promise((resolve, reject) => {
        window.grecaptcha.enterprise.ready(async () => {
            try {
                const token = await window.grecaptcha.enterprise.execute(reCaptchaId, { action });

                resolve(token);
            } catch (error) {
                reject(error);
            }
        });
    });
}

export function getReCaptchaIdFromTag() {
    const tag = document.querySelector('[data-recaptcha-id]');

    if (!tag) {
        throw new Error('An element with data-recaptcha-id was not found in the DOM');
    }

    return tag.dataset.recaptchaId;
}

export const login = makeExecuteForAction(actions.LOGIN);
export const signup = makeExecuteForAction(actions.SIGNUP);

function makeExecuteForAction(action) {
    return async () => {
        const reCaptchaId = getReCaptchaIdFromTag();

        try {
            return await execute({
                reCaptchaId,
                action
            });
            // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return '';
        }
    };
}